import { create } from 'zustand';

const useHomeFilterButtons = create((set) => ({
    selectedFilterValue: 'All',
    setSelectedFilterValue: (selectedFilterValue) => set({ selectedFilterValue }),
}));

export default useHomeFilterButtons;